import { c as _c } from "react/compiler-runtime";
import type { IconWrapperProps } from './Icon.types';
import { getIconSize, getStrokeWidth } from './IconUtils';
const IconWrapper = t0 => {
  const $ = _c(36);
  let ariaLabel;
  let children;
  let dataTestId;
  let decorative;
  let isInline;
  let size;
  let strokeWidth;
  let svgProps;
  let t1;
  let title;
  let variant;
  let viewBox;
  if ($[0] !== t0) {
    const {
      children: t2,
      decorative: t3,
      size: t4,
      title: t5,
      variant: t6,
      isInline: t7,
      contrast: _contrast,
      disabled: _disabled,
      ariaLabel: t8,
      color: t9,
      strokeWidth: t10,
      viewBox: t11,
      dataTestId: t12,
      ...t13
    } = t0;
    children = t2;
    decorative = t3;
    size = t4;
    title = t5;
    variant = t6;
    isInline = t7;
    ariaLabel = t8;
    t1 = t9;
    strokeWidth = t10;
    viewBox = t11;
    dataTestId = t12;
    svgProps = t13;
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = children;
    $[3] = dataTestId;
    $[4] = decorative;
    $[5] = isInline;
    $[6] = size;
    $[7] = strokeWidth;
    $[8] = svgProps;
    $[9] = t1;
    $[10] = title;
    $[11] = variant;
    $[12] = viewBox;
  } else {
    ariaLabel = $[1];
    children = $[2];
    dataTestId = $[3];
    decorative = $[4];
    isInline = $[5];
    size = $[6];
    strokeWidth = $[7];
    svgProps = $[8];
    t1 = $[9];
    title = $[10];
    variant = $[11];
    viewBox = $[12];
  }
  const color = t1 === undefined ? "currentColor" : t1;
  let t2;
  if ($[13] !== size) {
    t2 = getIconSize({
      size
    });
    $[13] = size;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  const iconSize = t2;
  let t3;
  if ($[15] !== strokeWidth) {
    t3 = getStrokeWidth({
      strokeWidth
    });
    $[15] = strokeWidth;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  const iconStrokeWidth = t3;
  const fill = variant === "solid" || variant === "hybrid" ? color : "none";
  const stroke = variant === "outline" || variant === "hybrid" ? color : "none";
  const iconViewBox = viewBox ?? "0 0 24 24";
  const t4 = decorative ? false : undefined;
  const t5 = decorative ? "presentation" : "img";
  const t6 = isInline ? "inline" : undefined;
  let t7;
  if ($[17] !== t6) {
    t7 = {
      display: t6
    };
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== title) {
    t8 = title && <title>{title}</title>;
    $[19] = title;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== ariaLabel || $[22] !== children || $[23] !== dataTestId || $[24] !== decorative || $[25] !== fill || $[26] !== iconSize || $[27] !== iconStrokeWidth || $[28] !== iconViewBox || $[29] !== stroke || $[30] !== svgProps || $[31] !== t4 || $[32] !== t5 || $[33] !== t7 || $[34] !== t8) {
    t9 = <svg width={iconSize} height={iconSize} viewBox={iconViewBox} fill={fill} stroke={stroke} strokeWidth={iconStrokeWidth} xmlns="http://www.w3.org/2000/svg" aria-hidden={decorative} focusable={t4} aria-label={ariaLabel} role={t5} data-test-id={dataTestId} style={t7} {...svgProps}>{t8}{children}</svg>;
    $[21] = ariaLabel;
    $[22] = children;
    $[23] = dataTestId;
    $[24] = decorative;
    $[25] = fill;
    $[26] = iconSize;
    $[27] = iconStrokeWidth;
    $[28] = iconViewBox;
    $[29] = stroke;
    $[30] = svgProps;
    $[31] = t4;
    $[32] = t5;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  return t9;
};
export { IconWrapper };